Jelly.Utilities.Force_URL = function(Path) {
	window.clearInterval(Jelly.Watch_Address_Bar_Interval);

	// Process new path exactly like I would in Watch_Address_Bar 
	{
		New_Path = Path;
		var Pound_Position = New_Path.indexOf("#");
		if (Pound_Position > -1)
		{
			New_Path = New_Path.substring(Pound_Position + 1);
		}
		else
		{
			var Base_Position = New_Path.indexOf("http://");
			if (Base_Position > -1)
				New_Path = New_Path.substring(Base_Position + "http://".length + 1);
			var SSL_Base_Position = New_Path.indexOf("https://");
			if (SSL_Base_Position > -1)
				New_Path = New_Path.substring(SSL_Base_Position + "https://".length + 1);
			var Slash_Position = New_Path.indexOf("/");
			if (Slash_Position > -1)
				New_Path = New_Path.substring(Slash_Position + 1);
		}
		
		// Strip slashes
		New_Path = New_Path.replace(/^\/*/, "");
		New_Path = New_Path.replace(/\/*$/, "");
	}
		
	// Push this new path
	Jelly.Current_Path = New_Path;

	// State change to original path
	window.history.pushState(null, null, Path);
	Jelly.Watch_Address_Bar_Interval = window.setInterval(Jelly.Watch_Address_Bar, 100);
}